import { render, staticRenderFns } from "./alphabet-control.vue?vue&type=template&id=9a70adba&"
import script from "./alphabet-control.vue?vue&type=script&lang=js&"
export * from "./alphabet-control.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\Kentico\\Launchpad.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('9a70adba', component.options)
    } else {
      api.reload('9a70adba', component.options)
    }
    module.hot.accept("./alphabet-control.vue?vue&type=template&id=9a70adba&", function () {
      api.rerender('9a70adba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/custom/vue/components/ui/alphabet-control.vue"
export default component.exports